import React, { useState } from "react";
import { Check, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { TemplateTextArea } from "../faqs/TemplateTextArea";
import { useCreateCannedResponse } from "./hooks/canned-responses.hooks";

interface CreateCannedResponseItemProps {
  categoryId: string;
  onCancel: () => void;
  onSuccess?: () => void;
}

export const CreateCannedResponseItem: React.FC<
  CreateCannedResponseItemProps
> = ({ categoryId, onCancel, onSuccess }) => {
  const { t } = useTranslation();
  const createCannedResponse = useCreateCannedResponse();
  const [data, setData] = useState({
    text: "",
  });
  const normalizedText = data.text.trim();

  const handleSave = () => {
    if (categoryId && normalizedText) {
      createCannedResponse.mutate(
        {
          text: normalizedText,
          categoryId,
        },
        {
          onSuccess: () => {
            onSuccess?.();
            onCancel();
          },
        },
      );
    }
  };

  return (
    <div
      className="border-base-border bg-secondary-badge flex flex-col gap-4 rounded-xl border p-4"
      onClick={(e) => e.stopPropagation()}
    >
      <h3 className="text-sm font-semibold text-black/96">
        {t("chats.cannedResponsesManagement.create")}
      </h3>
      <TemplateTextArea
        label={t("chats.cannedResponsesManagement.responseLabel")}
        placeholder={t("chats.cannedResponsesManagement.responsePlaceholder")}
        value={data.text}
        onChange={(val) => setData({ ...data, text: val })}
        actions={
          <div className="flex justify-end gap-2">
            <Button variant="new_outline" onClick={onCancel}>
              <X /> {t("common.cancel")}
            </Button>
            <Button
              variant="new_default"
              onClick={handleSave}
              disabled={!normalizedText || createCannedResponse.isPending}
            >
              <Check /> {t("common.save")}
            </Button>
          </div>
        }
      />
    </div>
  );
};
